import { Image, Text, View } from "@react-pdf/renderer";
import React from "react";

const headerImageStyle = {
  maxWidth: "100",
  maxHeight: "80",
};

const headerEmptyImageStyle = {
  width: "100",
  height: "80",
};

const SeasonHeader = ({ fixture }) => {
  const seasonStartDate = Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(fixture.seasonStartDate));
  const seasonEndDate = Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(fixture.seasonEndDate));
  const seasonDateStr = `${seasonStartDate} - ${seasonEndDate}`;
  const venueLocationStr = [fixture?.address?.city, fixture?.venueCountryCode]
    .filter((s) => !!s)
    .join(", ");
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-around",
        borderBottom: "1 solid black",
        paddingBottom: 6,
      }}
    >
      {fixture?.seasonLogoUrl ? (
        <Image src={fixture.seasonLogoUrl} style={headerImageStyle} />
      ) : (
        <View style={headerEmptyImageStyle}></View>
      )}
      <View style={{ alignItems: "center" }}>
        <Text style={{ fontSize: "13", fontWeight: "bold" }}>
          {fixture.seasonName}
        </Text>
        <Text style={{ fontSize: "11", fontWeight: "bold" }}>
          {seasonDateStr}
        </Text>
        <Text style={{ fontSize: "11", fontWeight: "bold" }}>
          {venueLocationStr}
        </Text>
      </View>
      {fixture?.competitionLogoUrl ? (
        <Image src={fixture.competitionLogoUrl} style={headerImageStyle} />
      ) : (
        <View style={headerEmptyImageStyle}></View>
      )}
    </View>
  );
};

export default SeasonHeader;
